
import React from "react";
import { Card, CardHeader, CardContent, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Rocket } from "lucide-react";
import { AIStaffMember } from "@/lib/types";

interface AssistantCardProps {
  aiStaff: AIStaffMember | null;
  onComplete: () => void;
}

const AssistantCard: React.FC<AssistantCardProps> = ({ aiStaff, onComplete }) => {
  return (
    <Card className="bg-primary/5 border-primary/20 transition-all duration-300 hover:shadow-md">
      <CardHeader>
        <CardTitle className="flex items-center">
          <Rocket className="h-5 w-5 mr-2 text-primary" />
          Your AI Assistant
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {aiStaff ? (
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <div className="h-12 w-12 rounded-full bg-primary/20 flex items-center justify-center text-2xl border border-primary/30 animate-pulse-gentle">
                {aiStaff.avatar || "🤖"}
              </div>
              <div>
                <h4 className="font-medium">{aiStaff.name}</h4>
                <p className="text-sm text-muted-foreground capitalize">
                  {aiStaff.role} Assistant ({aiStaff.level})
                </p>
              </div>
            </div>
            
            <div className="space-y-2">
              <h4 className="font-medium text-sm">Abilities:</h4>
              <ul className="text-sm text-muted-foreground space-y-1">
                {aiStaff.abilities.map((ability, index) => (
                  <li key={index} className="flex items-start">
                    <span className="text-primary mr-2">•</span> 
                    {ability}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ) : (
          <p>Finalizing your AI assistant information...</p>
        )}
        
        <Button 
          onClick={onComplete} 
          className="w-full mt-4 transition-all duration-300 hover:scale-105"
        >
          Complete Setup & Go to Dashboard
        </Button>
      </CardContent>
    </Card>
  );
};

export default AssistantCard;
